// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"9ca9368d","70":"9ca9368d","758":"bd62799f"}[chunkId] + ".chunk.css";
};